import { request } from './client';
import type { Check } from './types';

/**
 * The check this session is for.
 *
 * There is no id in the path: the check lives in the session token's signature, so there is nothing here for
 * a guest to edit their way onto someone else's check.
 */
export function getCheck(token: string, signal?: AbortSignal): Promise<Check> {
    return request<Check>('/check', { token, signal });
}
